import { connect } from 'react-redux';

import { getItemsList } from '../../Items/itemsActions';
import {
  getOfficesShortList,
  getPublicZoneList,
} from '../../Offices/officesActions';
import { getTransferringRequestsList } from '../transferringRequestsActions';
import TransferringRequestsFilter from './TransferringRequestsFilter';

const TransferringRequestsFilterContainer = ({
  publicZoneList,
  getPublicZoneList,
  officesShortList,
  getOfficesShortList,
  getTransferringRequestsList,
  selectedOrganization,
  getItemsList,
  itemsList,
  setSelectedParams,
  selectedParams,
}) => {
  return (
    <TransferringRequestsFilter
      publicZoneList={publicZoneList}
      getPublicZoneList={getPublicZoneList}
      officesShortList={officesShortList}
      getOfficesShortList={getOfficesShortList}
      getTransferringRequestsList={getTransferringRequestsList}
      selectedOrganization={selectedOrganization}
      getItemsList={getItemsList}
      itemsList={itemsList}
      setSelectedParams={setSelectedParams}
      selectedParams={selectedParams}
    />
  );
};

const mapStateToProps = state => ({
  publicZoneList: state.office.publicZoneList,
  officesShortList: state.office.officesShortList,
  selectedOrganization: state.organization.selectedOrganization,
  itemsList: state.items.itemsList,
});

const mapDispatchToProps = dispatch => ({
  getPublicZoneList: params => dispatch(getPublicZoneList(params)),
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),
  getTransferringRequestsList: params =>
    dispatch(getTransferringRequestsList(params)),
  getItemsList: params => dispatch(getItemsList(params)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TransferringRequestsFilterContainer);
